import React, { memo, useEffect, useState } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import {
  AdultIcon,
  ChildIcon,
  BabyIcon,
  PlusIcon,
  MinusIcon,
  SeniorIcon,
  InfantChairIcon,
  PlusCircleIcon,
  MinusCircleIcon,
} from '~svg/index';
import './selectPassengerCount.scss';
const SelectPassengerCount = ({ returnPassenger, ...props }) => {
  // useState of component
  const [finalPassengerValues, setFinalPassengerValues] = useState({
    adult: props.adultCount ? props.adultCount : 1,
    child: props.childCount ? props.childCount : 0,
    infant: props.infantCount ? props.infantCount : 0,
    senior: props.seniorCount ? props.seniorCount : 0,
    toddler: props.toddlerCount ? props.toddlerCount : 0,
  });
  const normalPassenger = ['adult', 'child', 'infant'];
  const customePassenger = [...normalPassenger, 'senior', 'toddler'];
  const [passengerType, setPassengerType] = useState(normalPassenger);
  const [showMore, setShowMore] = useState(false);
  useEffect(() => {
    if (showMore) {
      setPassengerType(customePassenger);
    } else {
      setPassengerType(normalPassenger);
    }
  }, [showMore]);
  // handle Buttons
  const handlePassengerCount = (number, currentChoice) => {
    if (
      (currentChoice === 'adult' &&
        number + finalPassengerValues.senior <
          finalPassengerValues.infant + finalPassengerValues.toddler) ||
      (currentChoice === 'senior' &&
        number + finalPassengerValues.adult <
          finalPassengerValues.infant + finalPassengerValues.toddler)
    ) {
      if (finalPassengerValues.infant > 0) finalPassengerValues.infant -= 1;
      else finalPassengerValues.toddler -= 1;
    }
    finalPassengerValues[currentChoice] = number;
    setFinalPassengerValues(finalPassengerValues);
    returnPassenger(finalPassengerValues);
  };
  const increment = (currentChoice) => {
    let total =
      finalPassengerValues.adult +
      finalPassengerValues.child +
      finalPassengerValues.senior +
      finalPassengerValues.toddler;
    if (currentChoice === 'infant') {
      if (
        finalPassengerValues['adult'] + finalPassengerValues['senior'] >
        finalPassengerValues[currentChoice] + finalPassengerValues['toddler']
      )
        handlePassengerCount(
          finalPassengerValues[currentChoice] + 1,
          currentChoice,
        );
    } else if (currentChoice === 'toddler' && total < 9) {
      if (
        finalPassengerValues['adult'] + finalPassengerValues['senior'] >
        finalPassengerValues[currentChoice] + finalPassengerValues['infant']
      )
        handlePassengerCount(
          finalPassengerValues[currentChoice] + 1,
          currentChoice,
        );
    } else {
      total < 9
        ? handlePassengerCount(
            finalPassengerValues[currentChoice] + 1,
            currentChoice,
          )
        : null;
    }
  };
  const decrement = (currentChoice) => {
    if (
      currentChoice === 'adult' &&
      finalPassengerValues[currentChoice] + finalPassengerValues.senior === 1
    )
      return null;
    if (
      currentChoice === 'senior' &&
      finalPassengerValues[currentChoice] + finalPassengerValues.adultd === 1
    )
      return null;
    else if (finalPassengerValues[currentChoice] > 0)
      handlePassengerCount(
        finalPassengerValues[currentChoice] - 1,
        currentChoice,
      );
    else return null;
  };

  return (
    <div
      className={`selectPassengerCount border-bottom border-top border-third mb-4 mb-md-0
    mobile-shadow  py-4 px-4  p-md-0 `}
    >
      <div
        className={`  px-sm-2
      d-flex flex-column justify-content-around justify-content-lg-between text-gray h-100 
       py-md-3 py-lg-4  `}
      >
        <div
          className={` align-items-center justify-content-around d-flex position-relative p-0  py-1 py-lg-0  border  flex-column
          border-third default-border-radius-xsmall bg-white  font-smaller font-xs-msmall font-sm-normal font-md-smaller font-lg-msmall font-xl-small font-xxl-normal`}
        >
          {passengerType.map((item) => {
            return (
              <div
                className="d-flex w-100 position-relative user-select-none align-items-center items text-center items
                 py-2 "
                key={item}
              >
                <div className="col-3">
                  {item === 'adult' ? (
                    <AdultIcon size={20} color="#6c757d" />
                  ) : item === 'child' ? (
                    <ChildIcon size={20} color="#6c757d" />
                  ) : item === 'senior' ? (
                    <SeniorIcon size={20} color="#6c757d" />
                  ) : item === 'infant' ? (
                    <BabyIcon size={20} color="#6c757d" />
                  ) : (
                    <InfantChairIcon size={20} color="#6c757d" />
                  )}
                </div>

                <span className=" w-100 text-start">
                  {props.intl.formatMessage({ id: `booking.${item}` })}
                </span>
                <div
                  className={`d-flex align-items-center justify-content-center col-5 ${
                    props.language.direction == 'ltr' && 'flex-row-reverse'
                  }`}
                >
                  <div
                    className="cursor-pointer"
                    onClick={() => increment(item)}
                  >
                    <PlusIcon size={12} color="#6c757d" />
                  </div>
                  <span className={` font-weight-bold col-5`}>
                    {finalPassengerValues[item]}
                  </span>
                  <div
                    className="cursor-pointer"
                    onClick={() => decrement(item)}
                  >
                    <MinusIcon size={12} color="#6c757d" />
                  </div>
                </div>
              </div>
            );
          })}
        </div>
        <div
          className="d-flex w-100 text-gray mt-2 font-smaller justify-content-end align-items-center pointer px-2"
          onClick={() => setShowMore(!showMore)}
        >
          <div className="d-flex align-items-center px-2">
            {!showMore ? (
              <PlusCircleIcon size={12} color="#6c757d" />
            ) : (
              <MinusCircleIcon size={12} color="#6c757d" />
            )}
          </div>

          <span className="d-flex px--md-3 px-0 py-2 font-smaller">
            {!showMore
              ? props.intl.formatMessage({ id: 'dashboard.showmore' })
              : props.intl.formatMessage({ id: 'profile.showLess' })}
          </span>
        </div>
      </div>
    </div>
  );
};
function mapStateToProps(state, props) {
  return {
    language: state.language,
  };
}
export default injectIntl(connect(mapStateToProps)(memo(SelectPassengerCount)));
